export default __webpack_public_path__ + "static/media/Intimation-of-Earnings-Call-Q2FY27.c420255c.pdf";